/**
 * Digitale Karte — Mittagsmenü live nachladen
 * ---------------------------------------------------------------------------
 * Das Highlight-Band rendert serverseitig, welcher Wochentag "heute" ist
 * ('now' in der Shop-Zeitzone). Ausgeliefert wird die Seite aber aus Shopifys
 * Full-Page-Cache: der QR-Code am Tisch kann eine HTML-Fassung von gestern
 * bekommen — dann steht der falsche Tag als "heute" da, und ein Menü, das
 * heute Vormittag freigegeben wurde, fehlt.
 *
 * Deshalb holt dieses Skript das Band nach dem Laden noch einmal einzeln über
 * Shopifys Section Rendering API (?section_id=…). Diese Antwort wird frisch
 * gerendert; der Cache-Buster im Query-String und cache:"no-store" halten
 * zusätzlich Browser- und Zwischencaches heraus.
 *
 * Nachgeladen wird
 *   - einmal beim Laden,
 *   - beim Zurückspringen aus dem bfcache (Back-Button),
 *   - wenn der Tab nach mehr als 5 Minuten wieder sichtbar wird (das Handy
 *     liegt am Tisch, die Küche wechselt aufs Mittagsmenü).
 *
 * Ohne JavaScript bleibt der servergerenderte Stand stehen — die Karte
 * funktioniert weiterhin, nur eben mit dem Stand der zwischengespeicherten
 * Seite.
 */
(function () {
  var script = document.querySelector("script[data-karte-live]");
  if (!script || !window.fetch || !window.DOMParser) return;

  var sectionId = script.getAttribute("data-karte-live");
  var wrapper = script.closest(".shopify-section") || script.parentElement;
  var BAND = ".karte-highlight";
  var MINDESTPAUSE = 5 * 60 * 1000;

  if (!sectionId || !wrapper) return;

  var letzteAktualisierung = Date.now();
  var laeuft = false;
  /* Nur ein selbst gewählter Tag wird über ein Nachladen hinweg gehalten.
     Ohne Interaktion gewinnt immer der Server — sonst bliebe über Mitternacht
     hinweg der gestrige Tag stehen. Der Listener hängt am Section-Wrapper und
     überlebt den Austausch des Bandes. */
  var gewaehlterTag = "";
  wrapper.addEventListener("change", function (event) {
    var ziel = event.target;
    if (ziel && ziel.matches && ziel.matches(".karte-lunch__tab input")) {
      gewaehlterTag = ziel.value;
    }
  });

  function aktualisieren() {
    if (laeuft) return;
    laeuft = true;

    var url = window.location.pathname + "?section_id=" + encodeURIComponent(sectionId) + "&_=" + Date.now();

    fetch(url, { cache: "no-store", credentials: "same-origin" })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error(antwort.status);
        return antwort.text();
      })
      .then(function (html) {
        var frisch = new DOMParser().parseFromString(html, "text/html").querySelector(BAND);
        var aktuell = wrapper.querySelector(BAND);

        if (!frisch) {
          /* Nichts mehr zu zeigen (Menü zurückgezogen, Text geleert) — dann
             verschwindet das Band, ohne eine Lücke im Rhythmus zu lassen. */
          if (aktuell) aktuell.remove();
          wrapper.hidden = true;
          return;
        }

        if (aktuell) {
          aktuell.replaceWith(frisch);
          /* Blättert der Gast gerade durch die Woche, bleibt sein Tag stehen —
             sonst spränge die Auswahl beim Nachladen zurück auf heute. Erst
             NACH dem Einhängen setzen: davor gewinnt das checked-Attribut aus
             der frischen Antwort. */
          if (gewaehlterTag) {
            var frischesRadio = frisch.querySelector('.karte-lunch__tab input[value="' + gewaehlterTag + '"]');
            if (frischesRadio) frischesRadio.checked = true;
          }
        } else {
          wrapper.insertBefore(frisch, wrapper.firstChild);
        }
        wrapper.hidden = false;
      })
      .catch(function () {
        /* Kein Netz, Section umbenannt, 4xx: der gerenderte Stand bleibt. */
      })
      .then(function () {
        laeuft = false;
        letzteAktualisierung = Date.now();
      });
  }

  aktualisieren();

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) aktualisieren();
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState !== "visible") return;
    if (Date.now() - letzteAktualisierung < MINDESTPAUSE) return;
    aktualisieren();
  });
})();
